<template>
  <div class="courses">
    <el-row :gutter="20" type="flex flex-wrap" align="top">
      <el-col :sm="24" :md="12">
        <div class="courses__header">
          <svg-icon name="arrow-left" @click="$router.push({ name: 'courses' })" />
          <h2 class="course__title">Курсы</h2>
        </div>
      </el-col>
      <el-col :sm="24" :md="12">
        <div class="courses__header-btn">
          <template v-if="getActiveFormRoute === 'overview'">
            <el-button plain round type="danger">Удалить</el-button>
            <el-button type="success" round @click="editCourse">Редактировать</el-button>
          </template>
          <template v-else>
            <el-button plain round>Отменить</el-button>
            <el-button type="success" round @click="saveCourse">Сохранить</el-button>
          </template>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="flex flex-wrap flex-1">
      <el-col :md="24" :lg="10" class="mobile-mb-16">
        <el-card class="w-height">
          <div class="courses__structure">
            <p class="courses__structure-title">Структура курса</p>
            <ul>
              <li class="courses__structure-name">{{ courseData.name }}</li>
              <li
                v-for="(course, index) in courseData.data"
                :key="index"
                class="courses__structure-level"
                @click="showCourseByLevel(course, index)"
              >
                <i
                  :class="[course.isActive ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"
                  @click.stop="toggleIcon(course)"
                />
                <span>{{ course.module }}</span>
                <ul v-if="course.children && course.isActive">
                  <li
                    v-for="(days, i) in course.children"
                    :key="i"
                    class="courses__structure-days"
                    @click.stop="showCourseByDay(days, i)"
                  >
                    <i
                      :class="[days.isActive ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"
                      @click.stop="toggleIcon(days)"
                    />
                    <span>{{ days.day }}</span>
                    <ul v-if="days.children && days.isActive">
                      <li
                        v-for="(day, ind) in days.children"
                        :key="ind"
                        class="courses__structure-day"
                      >
                        {{ day.tasks }}
                        <ul v-if="day.children">
                          <li
                            v-for="(item, indx) in day.children"
                            :key="indx"
                            @click.stop="showCourseByTask(item, indx)"
                          >
                            {{ item.task }}
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </el-card>
      </el-col>

      <el-col :md="24" :lg="9">
        <el-card class="w-height">
          <div class="w-full">
            <OverviewCourse
              v-if="getActiveFormRoute === 'overview'"
              :form-model="courseForm"
              :course-data="tableData"
            />
            <OverviewCourseModules
              v-if="getActiveFormRoute === 'edit-module'"
              :form-model="courseForm"
              :course-data="tableData"
            />
            <OverviewCourseLevel
              v-if="getActiveFormRoute === 'edit-level'"
              :form-model="courseForm"
              :course-data="courseData"
            />
            <OverviewCourseDays
              v-if="getActiveFormRoute === 'edit-day'"
              :form-model="courseForm"
              :course-data="courseData"
            />
            <OverviewCourseTask
              v-if="getActiveFormRoute === 'edit-task'"
              :form-model="courseForm"
              :course-data="courseData"
            />
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import OverviewCourse from '@/components/Admins/Courses/OverviewCourse.vue'

export default {
  name: 'Course',
  components: {
    OverviewCourse,
    OverviewCourseModules: () =>
      import(
        /* WebpackChunkName: "modules" */ '@/components/Admins/Courses/OverviewCourseModules.vue'
      ),
    OverviewCourseLevel: () =>
      import(/* WebpackChunkName: "level" */ '@/components/Admins/Courses/OverviewCourseLevel.vue'),
    OverviewCourseDays: () =>
      import(/* WebpackChunkName: "days" */ '@/components/Admins/Courses/OverviewCourseDays.vue'),
    OverviewCourseTask: () =>
      import(/* WebpackChunkName: "task" */ '@/components/Admins/Courses/OverviewCourseTask.vue')
  },
  data: () => ({
    courseData: {
      name: 'Базовый курс',
      data: [
        { module: 'Вводно-речевой курс', isActive: false, children: [] },
        {
          module: 'Уровень владения языком А1',
          isActive: false,
          children: [
            {
              day: 'День 1. Буквы',
              isActive: false,
              children: [
                {
                  tasks: 'Основное',
                  children: [
                    {
                      task: 'Задание 1. А, О, У,  Э, И',
                      type: 'Основное',
                      taskType: 'Контент',
                      points: 5
                    },
                    {
                      task: 'Задание 2. А, О, У,  Э, И',
                      type: 'Основное',
                      taskType: '',
                      points: 6
                    },
                    { task: 'Задание 3. А, О, У,  Э, И' },
                    { task: 'Задание 4. А, О, У,  Э, И' },
                    { task: 'Задание 5. А, О, У,  Э, И' },
                    { task: 'Задание 6. А, О, У,  Э, И' }
                  ]
                },
                { tasks: 'Дополнительное', children: [] }
              ]
            },
            { day: 'День 2. Звук', isActive: false, children: [] },
            { day: 'День 3. Говорим', isActive: false, children: [] },
            { day: 'День 4. Говорим', isActive: false, children: [] }
          ]
        },
        {
          module: 'Уровень владения языком А2',
          isActive: false,
          children: []
        },
        {
          module: 'Уровень владения языком B1',
          isActive: false,
          children: []
        }
      ]
    },
    tableData: [
      {
        title: 'Русский язык как иностранный',
        description: ['Вводно-речевой курс'],
        score: 'А1, А2, В1',
        status: 'Активный',
        id: 1,
        minScore: 'Любой',
        amountScore: 'В1 (Пороговый уровень)'
      },
      {
        title: 'Базовый курс',
        description: [
          'Вводно-речевой курс',
          'Уровень владения языком А1',
          'Уровень владения языком А2',
          'Уровень владения языком B1'
        ],
        score: 'А1, А2, В1',
        status: 'Черновик',
        id: 2,
        minScore: 'Любой',
        amountScore: 'В1 (Пороговый уровень)'
      }
    ],
    courseForm: {},
    rules: {},
    active: 0,
    activeForm: 'overview'
  }),
  computed: {
    getActiveFormRoute() {
      return this.$route.name
    }
  },
  methods: {
    showCourseByLevel(course, index) {
      this.toggleIcon(course)
      this.$router.push({ name: 'edit-level', params: { levelId: index, course } })
    },

    showCourseByDay(day, index) {
      this.toggleIcon(day)
      this.$router.push({ name: 'edit-day', params: { dayId: index, day } })
    },

    showCourseByTask(task, index) {
      this.toggleIcon(task)
      this.$router.push({ name: 'edit-task', params: { taskId: index, task } })
    },

    editCourse() {
      this.$router.push({ name: 'edit-module' })
    },

    saveCourse() {},

    toggleIcon(courseItem) {
      courseItem.isActive = !courseItem.isActive
    }
  }
}
</script>

<style scoped lang="scss">
.courses {
  &__header {
    display: flex;
    align-items: center;
    margin-bottom: 50px;

    svg {
      margin-right: 20px;
      width: 20px;
      height: 20px;
    }

    h2 {
      font-weight: bold;
      font-size: 24px;
      letter-spacing: 0.35px;
      color: $luchmara;
    }
  }

  &__header-btn {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 0;

    @include sm-and-down {
      justify-content: center;
      margin-bottom: 20px;
    }
  }

  &__structure {
    padding-left: 20px;

    @include sm-and-down {
      padding-left: 0;
      width: 100%;
    }

    ul {
      margin-top: 10px;
    }
  }

  &__structure-title {
    margin-bottom: 40px;
    font-weight: bold;
    font-size: 24px;
    text-align: left;
    letter-spacing: 0.35px;
    color: $deepdark;

    @include sm-and-down {
      text-align: center;
    }
  }

  &__structure-name {
    margin-bottom: 24px;
    font-weight: 500;
    font-size: 19px;
    color: $deepdark;
  }

  &__structure-level {
    margin-bottom: 16px;
    font-weight: 500;
    font-size: 15px;
    color: $deepdark;

    ul {
      padding-left: 24px;
    }

    & > span {
      display: inline-block;
      margin-bottom: 16px;
      cursor: pointer;
    }

    i {
      margin-right: 10px;
    }
  }

  &__structure-days {
    margin-bottom: 16px;
    font-size: 15px;
    font-weight: normal;
    color: $deepdark;

    ul {
      padding-left: 16px;

      li {
        span {
          display: block;
          margin-bottom: 16px;
        }
      }
    }

    & > span {
      cursor: pointer;
    }

    i {
      margin-right: 10px;
    }
  }

  &__structure-day {
    font-size: 12px;
    color: #b6b9c3;

    &:last-child {
      margin-top: 10px;
    }

    ul {
      li {
        margin-bottom: 16px;
        font-size: 15px;
        color: $deepdark;
        list-style: disc;
      }
    }
  }
}

.mobile-mb-16 {
  margin-bottom: 0;

  @include lg-and-down {
    margin-bottom: 16px;
  }
}
</style>
